"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDrinkCardCouponGoodsList = getDrinkCardCouponGoodsList;
exports.getDrinkCardCouponLog = getDrinkCardCouponLog;
exports.retryCouponLog = retryCouponLog;
var _requestAuth = _interopRequireDefault(require("@/utils/requestAuth"));
function getDrinkCardCouponLog(orderSn) {
  return (0, _requestAuth.default)({
    url: '/drinkCardCouponLog/list',
    method: 'get',
    params: {
      orderSn: orderSn
    }
  });
}
function retryCouponLog(id) {
  return (0, _requestAuth.default)({
    url: '/drinkCardCouponLog/retry',
    method: 'post',
    params: {
      id: id
    }
  });
}
function getDrinkCardCouponGoodsList(orderId) {
  return (0, _requestAuth.default)({
    url: '/drinkCardCouponLog/goodsList',
    method: 'get',
    params: {
      orderId: orderId
    }
  });
}